import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import api from '../../utils/api';

const TABS = [
  { path: '/warehouse-dashboard', key: 'nav.warehouseDashboard', roles: ['warehouse'] },
  { path: '/dashboard', key: 'nav.dashboard', roles: ['admin', 'accounting', 'brand_manager', 'viewer', 'account_manager'] },
  { path: '/orders', key: 'nav.orders', roles: ['admin', 'accounting', 'brand_manager', 'viewer', 'account_manager'] },
  { path: '/logistics', key: 'nav.logistics', roles: ['admin', 'brand_manager', 'warehouse', 'viewer', 'account_manager'] },
  { path: '/warehouse', key: 'nav.warehouse', roles: ['admin', 'warehouse', 'viewer', 'account_manager'] },
  { path: '/cellcom-orders', key: 'nav.cellcomOrders', roles: ['admin', 'warehouse', 'viewer', 'account_manager'] },
  { path: '/delivery-notes', key: 'nav.deliveryNotes', roles: ['admin', 'warehouse', 'viewer', 'account_manager'] },
  { path: '/customer-payments', key: 'nav.customerPayments', roles: ['admin'] },
  { path: '/fc-orders', key: 'nav.fcOrders', roles: ['admin', 'viewer'] },
  { path: '/prices', key: 'nav.prices', roles: ['admin', 'accounting', 'brand_manager', 'viewer', 'account_manager'] },
  { path: '/profitability', key: 'nav.profitability', roles: ['admin', 'accounting', 'viewer', 'account_manager'] },
  { path: '/uploads', key: 'nav.uploads', roles: ['admin', 'account_manager'] },
  { path: '/serial-numbers', key: 'nav.serialNumbers', roles: ['admin', 'warehouse'] },
  { path: '/settings', key: 'nav.settings', roles: ['admin'] },
];

export default function Navigation() {
  const { t } = useTranslation();
  const { hasRole, user } = useAuth();
  const isAdminOrCustomer = user?.role === 'admin' || user?.role === 'customer';
  const [fcBadge, setFcBadge] = useState(0);

  useEffect(() => {
    const check = () => api.get('/portal/fc-notifications').then(r => setFcBadge(r.data.count || 0)).catch(() => {});
    check();
    const interval = setInterval(check, 30000);
    return () => clearInterval(interval);
  }, []);

  const showPortal = hasRole('admin', 'accounting', 'brand_manager', 'viewer', 'customer');

  return (
    <nav className="nav-tabs" style={{ display: 'flex' }}>
      {TABS.filter(tab => hasRole(...tab.roles)).map(tab => (
        <NavLink
          key={tab.path}
          to={tab.path}
          className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}
          style={{ position: 'relative' }}
          onClick={() => { if (tab.path === '/fc-orders' && fcBadge > 0 && isAdminOrCustomer) { api.put('/portal/fc-seen').then(() => setFcBadge(0)).catch(() => {}); } }}
        >
          {t(tab.key)}
          {tab.path === '/fc-orders' && fcBadge > 0 && (
            <span style={{ position: 'absolute', top: -4, right: -4, background: '#dc2626', color: '#fff', fontSize: 10, fontWeight: 800, width: 18, height: 18, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{fcBadge}</span>
          )}
        </NavLink>
      ))}
      {showPortal && (
        <NavLink
          to="/portal"
          className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}
          style={{ background: '#1565c0', color: '#fff', borderRadius: 6, padding: '6px 16px', fontWeight: 700, position: 'relative', marginInlineStart: 'auto', flexShrink: 0, alignSelf: 'center', whiteSpace: 'nowrap' }}
          onClick={() => { if (fcBadge > 0 && isAdminOrCustomer) { api.put('/portal/fc-seen').then(() => setFcBadge(0)).catch(() => {}); } }}
        >
          {t('nav.portal')}
          {fcBadge > 0 && (
            <span style={{ position: 'absolute', top: -6, right: -6, background: '#dc2626', color: '#fff', fontSize: 10, fontWeight: 800, minWidth: 18, height: 18, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #fff' }}>{fcBadge}</span>
          )}
        </NavLink>
      )}
    </nav>
  );
}
